module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0d7fd10d6285a8b523e17d424c07d35a.png";